import React from "react";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import InputField from "../common/InputField/InputField";
import { Button } from "../common/Button/Button";
import { useAuthForm } from "../../hooks/useAuthForm";
import { AuthLayout } from "./AuthLayout/AuthLayout";

export const Login = () => {
  const {
    email,
    setEmail,
    password,
    setPassword,
    loading,
    setLoading,
    emailError,
    passError,
    resetErrors,
    handleError,
    isAuthenticated,
    login,
  } = useAuthForm();

  const { t } = useTranslation();

  const handleLogin = async () => {
    setLoading(true);
    resetErrors();
    try {
      await login(email, password);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  return (
    <AuthLayout>
      <InputField
        type="email"
        label={t("common.email")}
        placeholder="example@email.com"
        value={email}
        onChange={setEmail}
        required
        disabled={loading}
        errormessage={emailError}
      />
      <InputField
        type="password"
        label={t("common.password")}
        placeholder="*********"
        value={password}
        onChange={setPassword}
        required
        disabled={loading}
        errormessage={passError}
      />

      <Button
        text={t("common.login")}
        onClick={handleLogin}
        disabled={loading}
      />
    </AuthLayout>
  );
};
